window.SizeGuideModal = window.SizeGuideModal || {

  open: function (id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    // Teleport modal to <body> to escape any broken stacking context.
    if (modal.parentElement !== document.body) {
      modal._originalParent = modal.parentElement;
      document.body.appendChild(modal);
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    // Add class to <html> — CSS uses this to force every sticky/fixed
    // header behind the overlay via !important, which beats theme stylesheets.
    document.documentElement.classList.add('sg-modal-open');

    // Measure scrollbar width BEFORE locking scroll to prevent layout shift.
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--sg-scrollbar-width', scrollbarWidth + 'px');
    document.body.classList.add('sg-open');

    // Move focus into the modal for accessibility.
    var firstFocusable = modal.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (firstFocusable) firstFocusable.focus();
  },

  close: function (id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    // Remove the class that suppresses the header z-index.
    document.documentElement.classList.remove('sg-modal-open');

    // Unlock scroll and remove scrollbar compensation.
    document.body.classList.remove('sg-open');
    document.documentElement.style.removeProperty('--sg-scrollbar-width');

    // Return the modal to its original position in the DOM.
    if (modal._originalParent) {
      modal._originalParent.appendChild(modal);
      modal._originalParent = null;
    }
  },

  overlayClick: function (event, id) {
    if (event.target.id === id) {
      this.close(id);
    }
  },

  switchAttr: function (id, index) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.querySelectorAll('.sg-attr-tab').forEach(function (tab) {
      const active = Number(tab.dataset.tab) === index;
      tab.classList.toggle('sg-attr-tab--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    modal.querySelectorAll('.sg-attr-panel').forEach(function (panel) {
      const active = panel.id === id + '-panel-' + index;
      panel.classList.toggle('sg-attr-panel--active', active);

      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
};

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.sg-overlay.is-open').forEach(function (modal) {
    window.SizeGuideModal.close(modal.id);
  });
});